import * as types from './../actions/actionTypes';

const breakpoint = (state, action) => {
    switch (action.type) {
        case types.ACTIVE_BREAKPOINT_CHANGED:
            if (action.breakpointData) {
                return Object.assign({}, state, {
                    name: action.breakpointName,
                    data: action.breakpointData,
                });
            }
            break;

        default:
            return state;
    }
};

export default breakpoint;

export const getBreakpoint = state => state.stolo.ui.breakpoint;
export const getBreakpointMaxWidth = state => state.stolo.ui.breakpoint.data.max ||
        state.stolo.ui.breakpoint.data.windowWidth;
export const getWindowHeight = state => state.stolo.ui.breakpoint.data.windowHeight;
export const getWindowWidth = state => state.stolo.ui.breakpoint.data.windowWidth;



// WEBPACK FOOTER //
// ./src/reducers/breakpoint.js